import React, { useEffect } from 'react';
import BoardButton from '../BoardButton';
import '../modals/styles/HowToPlay.css';
import { useShowTimerPreference } from '../../helper/useShowTimerPreference';

const StartModal = ({ title, children, onStart, onClose, archived, difficulty, startLabel = 'Start' }) => {
    const [showTimer, setShowTimer] = useShowTimerPreference();

    useEffect(() => {
        const onKeyDown = (event) => {
            if (event.key === 'Escape' || event.key === 'Esc') onClose?.();
        };
        document.addEventListener('keydown', onKeyDown);
        return () => document.removeEventListener('keydown', onKeyDown);
    }, [onClose]);

    const handleStart = () => {
        setShowTimer(showTimer);
        onStart?.();
    };

    return (
        <div className={`howto-modal${archived ? ' archived-board-modal' : ''}`} role='dialog' aria-modal='true' tabIndex='-1'>
            <div className='howto-modal-content'>
                <h2 className='howto-modal-title'>{title}</h2>
                {difficulty && (
                    <span className={`board-difficulty-badge board-difficulty-${difficulty.toLowerCase()}`}>{difficulty}</span>
                )}
                {children}

                <div style={{ marginTop: '1rem' }}>
                    <BoardButton className='start-button' onClick={handleStart} label={startLabel}>{startLabel}</BoardButton>
                </div>

                <label className='archived-board-timer-confirmation'>
                    <input type='checkbox' checked={showTimer} onChange={() => setShowTimer((value) => !value)} />
                    Show timer
                </label>
            </div>
        </div>
    );
};

export default StartModal;
